module.exports = __webpack_public_path__ + "img/default.67edcff8.svg";